import CommentsLive from '../../service/comments';
import Config from '../../config';
import Module from '../../core/module';
import Tasks from '../../collection/tasks';
import TaskFilter from '../../view/tasks.filter';

import { newTask } from '../../view/task.new';
import { Insert } from '../../service/live';
import { fetch as fetchComments } from '../../collection/comments';
import { ask, } from '../../utils/popups';
import { del } from '../../http/api';
import { promisify, } from '../../utils/promisify';
import { beginLock, endLock } from '../../loader';





const     
    OPEN_TASK = 'tasks-form-open',
    OPEN_LIST = 'tasks-list-open',
    OPEN_MAP = 'tasks-map-open',
    OPEN_CONTRACTS = 'contracts-list-open';

export default Module.extend( {

    initialize(options = {}) {
        Module.prototype.initialize.call( this, options );

        const opts = () => {
            const { 
                datatables, clusters,
                types, organizations, contracts,
                statuses, priorities, fields, roles,
                serviceObjectMappings,
                locationService
            } = options;

            return { 
                datatables, clusters,
                locationService,
                types, organizations, contracts,
                statuses, priorities,
                fields,
                roles,
                serviceObjectMappings, 
            };
        };

        const actions = this.options.actions = {
            
            defaults: 'edit',
        
            multitask: {

                disabled: () => !Config.privileges().includes( 'create_task' ),

                handler: () => promisify( newTask( opts() ) )
                    .then( () => beginLock( this ) )
                    .then( () => fetch( this ) )
                    .then( () => endLock( this ) ),

            },
            
            edit: (current) =>
                this.trigger( OPEN_TASK, current ),
            
            destroy: {
        
                disabled: (current) => 
                    !current || !current.capabilities_.delete,

                handler: (current) =>
                    ask( 'issue::modal delete - confirmation text', undefined, 'actions::yes', 'actions::no',
                        () => del( `/tasks/${current.id}` ).blocking( this ).cerebellum().execute() )
                        .then( () => {
                            // deleting last task on the page?
                            if (issues.total == (this.state().page - 1) * 7 + 1)
                                // triggering page will force page change + reload + hash change
                                this.trigger( 'Paging:page', this.state().page - 1 );
                            else
                                beginLock( this ), fetch( this ).finally( () => endLock( this ) ); 
                        } ),
            }

        };
        
        const issues = this.options.issues = new Tasks( [], { actions: actions, } );

        this.setState( {
            filters: TaskFilter.defaultFilters(),
        } );

        this.commentsChannel = CommentsLive
            .filter( message => message instanceof Insert )
            .forEach( message => this.trigger( 'comments:income', message.model ) ); // model === attrs of Model
    },

    template: 'jst/module.tasks.list',

    url() {
        return 'tasks';
    },

    open() {
        return fetch( this )
            .then( () => this.render() )
            .then( () => {
                const filterModel = new TaskFilter.Model( this.state().filters );
                const current = this.options.issues.current();
                if (!current)
                    return this.Filter.bind( filterModel );

                return this.setState( { activeId: current.id } ),
                    Promise.all( [this.Filter.bind( filterModel ), this.Map.bind( current )] );
             } )
            .then( () => this );
    },

    start() {
        const { issues } = this.options;

        issues.plugActionSource( this.Grid );

        if (issues.current())
            this.Comments.bind( issues.current() );

        this.Map && this.Map.listenTo( issues, 'activate deactivate', 
            () => {
                const current = issues.current();
                const activeId = current ? current.id : undefined;
                if (this.state().activeId == activeId)
                    return;

                this.setState( { activeId, } );
                this.navigated();

                if (current && !current.comments_)
                    fetchComments( current.id ).then( ({ array }) =>
                        current.trigger( 'comments:load', current.comments_ = array ) );

                this.Map.bind( issues.current() );
                this.Comments.bind( issues.current() );
            } );

        this.listenTo( this, 'comments:income',
            comment => handleIncomingComment.call( this, comment ) );

        this.Filter.focus();
    },

    stop() {
        const { issues } = this.options;

        issues.unplugActionSource( this.Grid );
        this.Grid.ungrab( issues );
        this.Paging.ungrab( issues );

        this.stopListening( this.Paging );
        this.stopListening( this.Filter );
        this.stopListening( this, 'comments:income' );

        this.Map && this.Map.stopListening( issues );

        return this;
    },

    serialize() {
        const { issues, locationService, } = this.options;

        return {
            queryString: this.state().queryString || '',
            actionList: issues.actions,
            collection: issues,
            locationService,
        };
    },

    events: {

        'keyup [name=title]'(e) {
            if (13 == e.keyCode)
                this.Grid.trigger( 'action:default' ),
                e.preventDefault();
        },

        'keydown [name=title]'(e) {
            switch (e.keyCode) {
                case 38: 
                    this.options.issues.prevRow();
                    break;
                case 40: 
                    this.options.issues.nextRow();
                    break;
            }
        },

    },

    [Module.event( 'Paging:page' )](page) {
        return fetch( this, { page } ), this.navigated();
    },

    [Module.event( 'Filter:filter' )](filters) {
        return fetch( this, { filters, page: 1, } ), this.navigated();
    },

    [Module.event( 'Comments:comments:recalc-unread' )]() {
        this.Grid.render();
    },

    [Module.event( 'nav:map' )]() {
        this.trigger( OPEN_MAP, this.state() );
    },

    [Module.event( 'nav:contracts' )]() {
        this.trigger( OPEN_CONTRACTS, this.state() );
    },

}, {

    OPEN_TASK,

    OPEN_LIST,

    OPEN_MAP,

    OPEN_CONTRACTS,

} );

function handleIncomingComment(commentJson) {
    const taskId = +commentJson.task_id || +commentJson.news_id;
    const task = this.options.issues.find( m => m.id === taskId );
    if (!task)
        return;

    task.set( 'lastComment', commentJson );
    if (task.comments_ && task.comments_ instanceof Array)
        task.comments_.unshift( commentJson );

    if (commentJson.user_id == Config.userId())
        return task.set( 'unread_message_count', 0 ), this.Grid.render();

    const unread = task.get( 'unread_message_count' );
    if (unread === null)
        return this.Grid.render();

    task.set( 'unread_message_count', unread + 1 ),
    task.trigger( 'comments:unread-incoming' );

    this.Grid.render();
}

function fetch(self, { filters: newFilters, page: newPage, } = {}) {
    // no page, filters, id === preserve previous 
    if (newPage != undefined)
        self.setState( { page: +newPage } );
    if (newFilters != undefined)
        self.setState( { filters: newFilters } );

    const filters = Tasks.getHttpFilters( self.state() );
    const { page, activeId, } = self.state();

    return self.options.issues.seq( filters, page, activeId );
}



// WEBPACK FOOTER //
// ./src/js/module/tasks/list.js